/* eslint-disable @typescript-eslint/camelcase */
/* globals window */

export default function setANSDefaults({
  story,
  orgSettings,
  channels,
  websked,
}) {
  // wapo request
  if (
    orgSettings.ansOverrides &&
    orgSettings.ansOverrides.owner_name &&
    orgSettings.ansOverrides.owner_name.length
  ) {
    story.owner = story.owner || {}
    story.owner.name = story.owner.name || orgSettings.ansOverrides.owner_name
  }

  story.headlines = story.headlines || {}
  Object.keys(channels).forEach(function(type) {
    story.headlines[type] = story.headlines[type] || ''
  })

  story.subheadlines = story.subheadlines || {}
  story.subheadlines.basic = story.subheadlines.basic || ''

  if (!story.promo_items) {
    story.promo_items = {
      basic: {},
    }
  }

  // TODO: Eric - Inflate story ANS defaults via object
  story.credits = story.credits || {}
  story.credits.by = story.credits.by || []

  story.related_content = story.related_content || {}
  story.related_content.basic = story.related_content.basic || []

  story.taxonomy = story.taxonomy || {}
  story.taxonomy.sites = story.taxonomy.sites || []
  story.taxonomy.sections = story.taxonomy.sections || []

  story.address = story.address || {}
  story.geo = story.geo || {}

  story.workflow = story.workflow || {}
  if (!story._id) {
    if (websked.buttons === undefined || websked.buttons.length === 0) {
      story.workflow.status_code = 1
    } else {
      story.workflow.status_code = websked.buttons[0].id
    }
  }

  // todo: daniel: set this up to consume another deep inflate map like composebody
  story.content_elements = story.content_elements || []
  if (story.content_elements.length < 1) {
    story.content_elements.push({
      type: 'text',
      content: '',
      additional_properties: {
        comments: [],
      },
    })
  }

  story.planning = story.planning || {}
  story.planning.scheduling = story.planning.scheduling || {}
  story.planning.scheduling.planned_publish_date =
    story.planning.scheduling.planned_publish_date || ''
  story.planning.additional_properties =
    story.planning.additional_properties || {}

  return story
}
